<template>
  <div class="yydd-dialog">
    <div class="dialog">
      <a href="javascript:;" class="dialog-close" @click="close"></a>
      <div class="dialog-header">填写信息</div>
      <div class="dialog-body">
        <div class="dialog-item">
          <span>手机号</span>
          <div><input v-model="phone" type="tel" placeholder="请填写预约手机号" maxlength="11" @input="inputFn"/></div>
        </div>
        <template v-if="showCode">
          <div class="dialog-item">
            <span>图形码</span>
            <div>
              <input v-model="imgCode" type="text" placeholder="请输入图形码" maxlength="6"/>
              <img :src="imgSrc" alt="" @click="getPhoto">
            </div>
          </div>
          <div class="dialog-item">
            <span>验证码</span>
            <div>
              <input v-model="smsCode" type="number" placeholder="请输入验证码" maxlength="6"/>
              <p :class="{'disabled': count != 60}" @click="getCode">{{ codeMsg }}</p>
            </div>
          </div>
        </template>
        <div class="dialog-item" @click="showAddress">
          <span>所在地区</span>
          <div>
            <div :class="{'disabled': !address}">{{ address || '请选择地区'}}</div>
            <div class="icon-address"></div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="dialog-sure" @click="sure">提交</div>
      </div>
    </div>
    <van-popup round v-model="addressModel" position="bottom" :style="{height:'10rem', 'border-radius': '12px 12px 0 0'}" get-container="#app">
      <AddrSelect title="选择地址" v-if="addressModel" @success="addressSucess" @close="addressModel = false"/>
    </van-popup>
  </div>
</template>

<script>
import { sendMobileSms, createBusinessOpportunity } from '@/http/service/goods'
import { mapState, mapGetters } from 'vuex'
import AddrSelect from '@/components/addrSelect/addrSelect'

export default {
  name: 'yydd-dialog',
  components: {
    AddrSelect
  },
  data() {
    return {
      phone: '',
      smsCode: '',
      imgCode: '',
      imgSrc: '',
      address: '',

      showCode: false, //是否显示验证码
      addressModel: false, //地址选择

      interval: null,
      count: 60,
      codeMsg: '获取验证码',
    }
  },
  computed: {
    ...mapState({
      goodsDetailInfo: state => state.goodsDetail.goodsDetailInfo,
    }),
    ...mapGetters(['getUserInfo', 'getlocationInfo']),
  },
  mounted() {
    this.phone = this.getUserInfo.phone || ''
    this.address = (this.getlocationInfo.region + this.getlocationInfo.detailAddress) || ''
    this.getPhoto()
  },
  methods: {
    inputFn(e){
      console.log('input')
      let value = e.target.value
      value=value.replace(/[^\d]+/g,'')
      if(this.phone.length === 11 && this.phone !== this.getUserInfo.phone){
        this.showCode = true
      }else{
        this.showCode = false
      }
    },
    showAddress() {
      this.addressModel = true
    },
    addressSucess(){
      this.address = this.getlocationInfo.region + this.getlocationInfo.detailAddress
      this.addressModel = false
    },
    /**
     * @description  获取图片验证码
     */
    getPhoto() {
      let url = '/v3/platform/captcha/getSelfImgBase64.json';
      this.$http.get(this.$HOST + url + '?rnd=' + Math.random()).then(({ data }) => {
        let result = data;
        if (result.success) {
          this.imgSrc = 'data:image/png;base64,' + result.data
        } else {
          this.$toast(result.message)
        }
      })
    },
    async getCode(){
      if(!this.$util.isPhone(this.phone)){
        this.$toast('请输入正确的手机号')
        return 
      }
      if(!this.imgCode){
        return this.$toast('请输入图形码')
      }
      if(this.interval) return;
      const run = () => {
        if(this.count == 0){
          clearInterval(this.interval)
          this.interval = null
          this.count = 60
          this.codeMsg = '获取验证码'
        }else{
          this.count--
          this.codeMsg = this.count + 's'
        }
      }
      const { success, message } = await sendMobileSms({
        mobile: this.phone,
        imgCaptcha: this.imgCode,
      })
      console.log(success, message)
      if(!success){
        clearInterval(this.interval)
        this.interval = null
        this.count = 60
        this.codeMsg = '获取验证码'
        this.$toast(message)
        return
      }
      this.interval = setInterval(run, 1000)
      run()
      this.$toast('验证码已发送')
    },
    
    close(){
      this.$emit('close')
    },
    async sure(){
      if(!this.$util.isPhone(this.phone)){
        this.$toast('请输入正确的手机号')
        return 
      }
      let { success, message, data, errorCode } = await createBusinessOpportunity({
        phone: this.phone,
        smsCode: this.smsCode,
        address: this.address,
        storeCode: this.goodsDetailInfo.storeCode,
        mdCode: this.goodsDetailInfo.mdCode,
        productSku: this.goodsDetailInfo.sku,
        productName: this.goodsDetailInfo.productName,
        province: this.getlocationInfo.province,
        city: this.getlocationInfo.city,
        dict: this.getlocationInfo.district,
        street: this.getlocationInfo.township,
      })
      console.log(success, message, data)
      if(!success){
        this.$toast(message)
        if(errorCode == 'needSmsCode' ){
          this.showCode = true
        }
        return 
      }
      this.$toast('提交成功')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

.dialog{
  position: relative;
  padding: .48rem .4rem .32rem;
  background: #fff;
  border-radius: .24rem;
}

.dialog-close{
  position: absolute;
  top: .52rem;
  right: .32rem;
  width: .48rem;
  height: .48rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAADYAAAAAQAAANgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAEigAwAEAAAAAQAAAEgAAAAAHb16PAAAAAlwSFlzAAAhOAAAITgBRZYxYAAAAf9JREFUeAHtm21OwzAQRAvXoBfkDByDv3BW8EAthcqu7M1+jNBYiiKl9u6bVzc/ovRy0ZABGZABGZABGZABGZABGZABGZCBf2Lg2nJ8tOOtHU/EmcD22o73drxkckLO1+34bGdGSWACW+eEpLSBndMb48wm6V4OGLGT0sYIgEUSDRsNyGFb0DExATGxHL6z3xv08WZYcU+ildNNVQJW9u75l84VoBU9l2TMJmUCZ/aa5TVdzwDP6GEKv7ooMkBk7dV8LvMigkTUdAlrLeIZyLOWNU/IOo9gHjVCwnkVPRPwzFov/pQ6lqCWNSlhoprsBN6ZG8VbUncl+MqcEvispo8EPPosi4+iz0xE9ZMBCjkdYiSJ+VFu5049zyRRPMJ9TlWhZtsGZrun/8wodtF2KqcFIzkQopt0kzCTg+uPPnP6brjLrAhYmcOd0ki3E3xnrhGHa5klsGUNV+pFmjNBz6xdxKud5hHQo0athUl3z2CetSa4uZcjAkXUzLVy6xYZJLJ2iqyMABk9QmRlgmf2cpFVAVzR0ySrErSy95IsBkAGhqEsJjAmlh9ZdECNioaJBmSwrynY8FJ2fyxa8dLmwMufSyNJePk9beC1/i6I9bnxvST8fSJt4I8hkISdBBDWATbsHMi5skKKSwZkQAZkQAZkQAZkQAZkQAZkQAa2DHwD/gZlVOUjenIAAAAASUVORK5CYII=) no-repeat center;
  background-size: contain;
  z-index: 5;
}

.dialog-title{
  font-size: .32rem;
  color: #000;
  font-family: PingFangSC-Regular;
  text-align: center;
}

.dialog-header{
  height: .56rem;
  font-size: .4rem;
  line-height: .56rem;
  color: #000;
  opacity: 0.93;
  font-family: PingFangSC-Regular;
  text-align: center;
}

.dialog-body{
  padding: .64rem 0 1.04rem;
}

.dialog-item{
  height: 1.04rem;
  /* padding: 0 .24rem; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0,0,0,.1);
  box-sizing: border-box;
  &:last-child{
    margin-bottom: 0;
    > div > input{
      width: 3.4rem;
    }
  }
  >span{
    width: 1.78rem;
    font-size: .32rem;
    font-family: PingFangSC-Regular;
    color: #333;
  }
  > div{
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > img{
      width: 1.68rem;
      height: .64rem;
    }
    >input{
      width: 2.5rem;
      outline: none;
      font-size: .32rem;
      background: transparent;
      color: #333;
    }
    > div{
      width: 4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: .32rem;
      color: #333;
      &.disabled{
        color: gray;
      }
    }
    .icon-svg{
      display: inline-block;
      width: .24rem;
      height: .24rem;
      color: #ddd;
    };
    .icon-address{
      width: .48rem;
      height: .48rem;
      background: url(data:image/png;base64,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) no-repeat;
      background-size: contain;
    }
    > p{
      font-family: PingFangSC-Regular;
      font-size: .28rem;
      color: $themeSynMain;
      white-space: nowrap;
      &.disabled{
        color: #999;
      }
    }
  }
}

.dialog-footer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  >div{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: .88rem;
    font-size: .32rem;
    font-family: PingFangSC-Regular;
    border-radius: .44rem;
    box-sizing: border-box;
    color: #fff;
    background: $themeSynMain;
  }
}

.addr-select{
  padding: .4rem .24rem;
  background: #fff;
  max-height: 10rem;
  overflow-y: auto;
}

@supports (bottom: env(safe-area-inset-bottom)){
  .dialog{
    padding-bottom: calc(.2rem + env(safe-area-inset-bottom));
  }
}

:deep(.address-list){
  > div{
    padding-bottom: .2rem !important;
    height: calc(5.2rem - env(safe-area-inset-bottom));
    height: calc(5.2rem - constant(safe-area-inset-bottom));
  }
}
</style>